"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var login_service_1 = require("../../../services/login.service");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var expired_token_popup_component_1 = require("../expired-token-popup/expired-token-popup.component");
var TwoFactorAuthenticationComponent = /** @class */ (function () {
    function TwoFactorAuthenticationComponent(loginService) {
        this.loginService = loginService;
        this.verificationType = idm_authentication_client_js_1.VerificationType.EMAIL;
        this.verificationMessage = null;
        this.username = '';
        this.changeVerificationMethodScreen = false;
        this.showResendVerificationCodeSection = false;
    }
    TwoFactorAuthenticationComponent.prototype.ngOnChanges = function (changes) {
        this.checkVerificationMethod();
    };
    TwoFactorAuthenticationComponent.prototype.isVerificationMethodEmail = function () {
        return this.verificationType === idm_authentication_client_js_1.VerificationType.EMAIL;
    };
    TwoFactorAuthenticationComponent.prototype.isVerificationMethodSMS = function () {
        return this.verificationType === idm_authentication_client_js_1.VerificationType.SMS;
    };
    TwoFactorAuthenticationComponent.prototype.verify = function (event, code) {
        var _this = this;
        event.preventDefault();
        this.loginService
            .verify(code, this.verificationType)
            .then(function () { return _this.completeVerification && _this.completeVerification.emit(); })
            .catch(function (verificationObject) {
            _this.verificationMessage = verificationObject.message;
        });
    };
    TwoFactorAuthenticationComponent.prototype.changeVerificationMethod = function (event) {
        event.preventDefault();
        this.changeVerificationMethodScreen = true;
    };
    TwoFactorAuthenticationComponent.prototype.resend = function () {
        var _this = this;
        this.showResendVerificationCodeSection = true;
        this.loginService
            .resend(this.verificationType)
            .then(function () {
            _this.hideResendVerificationCodeSection();
        })
            .catch(function (verificationObject) {
            _this.verificationMessage = verificationObject.message;
            _this.hideResendVerificationCodeSection();
        });
    };
    TwoFactorAuthenticationComponent.prototype.hideResendVerificationCodeSection = function () {
        var _this = this;
        setTimeout(function () {
            _this.showResendVerificationCodeSection = false;
        }, 500);
    };
    TwoFactorAuthenticationComponent.prototype.chooseVerificationType = function (event, type) {
        event.preventDefault();
        switch (type) {
            case 'EMAIL':
                this.verificationType = idm_authentication_client_js_1.VerificationType.EMAIL;
                break;
            case 'SMS':
                this.verificationType = idm_authentication_client_js_1.VerificationType.SMS;
                break;
            default:
                throw new Error("No verification type = " + type + " exist!");
        }
        this.resend();
        this.changeVerificationMethodScreen = false;
        this.verificationMessage = '';
    };
    /**
      Checks, whether method of 2FA verification is supported.
    */
    TwoFactorAuthenticationComponent.prototype.checkVerificationMethod = function () {
        if (!(this.isVerificationMethodEmail() || this.isVerificationMethodSMS())) {
            throw new Error("Verification type " + this.verificationType + " is not supported!");
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], TwoFactorAuthenticationComponent.prototype, "verificationType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TwoFactorAuthenticationComponent.prototype, "verificationMessage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], TwoFactorAuthenticationComponent.prototype, "username", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", core_1.EventEmitter)
    ], TwoFactorAuthenticationComponent.prototype, "completeVerification", void 0);
    __decorate([
        core_1.ContentChild(expired_token_popup_component_1.ExpiredTokenPopupComponent),
        __metadata("design:type", core_1.ElementRef)
    ], TwoFactorAuthenticationComponent.prototype, "expiredTokenPopupComponent", void 0);
    TwoFactorAuthenticationComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-2fa',
            template: require('./two-factor-authentication.component.html')
        }),
        __metadata("design:paramtypes", [login_service_1.LoginService])
    ], TwoFactorAuthenticationComponent);
    return TwoFactorAuthenticationComponent;
}());
exports.TwoFactorAuthenticationComponent = TwoFactorAuthenticationComponent;
//# sourceMappingURL=two-factor-authentication.component.js.map